module.exports = __webpack_public_path__ + "img/33000.0677145b.jpg";